import React from 'react';

import styled from 'styled-components';

import { raiseUnderscore } from 'utils/helpers/string';

import AccommodationGroupCollapseHeaderStats from './AccommodationGroupCollapseHeaderStats';
import { useCareTypesContext } from '../CareTypesContext';
import { LivingInfoGroupedDataType } from '../types';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
`;

const Column = styled.div`
  margin-left: 4px;
`;

const Title = styled.div`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--text-primary);
`;

const Type = styled.div`
  font-family: var(--font-regular);
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  item: LivingInfoGroupedDataType;
};

const AccommodationGroupCollapseHeader = ({ item }: Props) => {
  const { careType } = useCareTypesContext();
  return (
    <Container data-test-id={`cd-accommodation-room-type-header-${raiseUnderscore(item.group_name).toLowerCase()}`}>
      <Column>
        <Title>{item.group_name}</Title>
        <Type>{careType?.type}</Type>
      </Column>
      <Column>
        <AccommodationGroupCollapseHeaderStats data={item.apartments} />
      </Column>
    </Container>
  );
};

export default AccommodationGroupCollapseHeader;
